import React from 'react';
import { Redirect } from 'react-router-dom';

export default function renderDashboardRedirect(pathname: string) {
  if (pathname === '/dashboard/create') {
    return <Redirect to="/team-dashboard/create" />;
  }

  if (pathname === '/dashboard/explore/submitted') {
    return <Redirect to="/team-dashboard/submitted" />;
  }

  if (pathname === '/dashboard/explore/drafts') {
    return <Redirect to="/team-dashboard/drafts" />;
  }

  if (pathname === '/dashboard/explore/subscribed') {
    return <Redirect to="/team-dashboard/subscribed" />;
  }

  if (pathname === '/dashboard/explore/tasks') {
    return <Redirect to="/my-assignments/explore/tasks" />;
  }
  if (pathname === '/dashboard/explore/assigned') {
    return <Redirect to="/my-assignments/explore/active-assignments" />;
  }
  if (pathname === '/dashboard/explore/completed') {
    return <Redirect to="/my-assignments/explore/completed-assignments" />;
  }

  if (pathname.includes('/dashboard/create')) {
    return <Redirect to="/team-dashboard/create" />;
  }

  return <Redirect to="/team-dashboard/overview" />;
}
